import { classNames } from "@ember-decorators/component";
import discourseTag from "discourse/helpers/discourse-tag";
import discourseComputed from "discourse/lib/decorators";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const TagRow = dt7948.c(class TagRow extends SelectKitRowComponent {
  isTag(item) {
    return item.id !== "no-tags" && item.id !== "all-tags";
  }
  static {
    dt7948.n(this.prototype, "isTag", [discourseComputed("item")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.isTag}}\n      {{discourseTag this.rowValue noHref=true description=this.item.description count=this.item.count}}\n    {{else}}\n      <span class=\"name\">{{this.item.name}}</span>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        discourseTag
      })
    }), this);
  }
}, [classNames("tag-row")]);
export default TagRow;